document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('[data-aeo-form]');

  forms.forEach((form) => {
    form.addEventListener('submit', function (event) {
      event.preventDefault();

      const websiteUrl = form.querySelector('[data-field="website"]').value.trim();
      const userEmail = form.querySelector('[data-field="email"]').value.trim();
      const phoneNumber = form.querySelector('[data-field="phone"]').value.trim();

      if (!websiteUrl || !userEmail || !phoneNumber) {
        alert('Please fill in all required fields');
        return;
      }

      const cleanPhone = phoneNumber.replace(/\D/g, '');
      if (cleanPhone.length < 10) {
        alert('Please enter a valid 10-digit phone number.');
        return;
      }

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{3,}$/.test(userEmail)) {
        alert('Enter valid email');
        return;
      }

      const submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting...';
      }

      const queryParams = new URLSearchParams({
        email: userEmail,
        website: websiteUrl,
        phone: phoneNumber,
        auditType: 'free',
      }).toString();

      const callbackName = 'handleResponse' + Date.now();

      window[callbackName] = function () {
        delete window[callbackName];
        window.location.href = '/pages/thank-you';
      };

      const script = document.createElement('script');
      script.src = `https://script.google.com/macros/s/AKfycbzo7qvPIu2z1c91DkNydJsDJqgoMWZyEE3w2Fcd5GkHLZAolbwZE5EAzuMur1MZ_hB-/exec?${queryParams}&callback=${callbackName}`;

      document.body.appendChild(script);
    });
  });
});